import React, { Component } from "react";
import { Link } from "react-router-dom";
import Data from "../Data/data";

export default class Work extends Component {
  renderList() {
    const list = Data.map(element => {
      return (
        <li key={element.index}>
          <Link to={`/work/${element.index}`} className="workImage">
            <img
              src={element.thumbnail}
              alt={element.title}
              onMouseEnter={() => this.props.runOnEnter()}
              onMouseLeave={() => {
                this.props.runOnLeave();
              }}
            />
          </Link>
          <Link to={`/work/${element.index}`} className="workText">
            <h3
              onMouseEnter={() => this.props.runOnEnter()}
              onMouseLeave={() => {
                this.props.runOnLeave();
              }}
            >
              {element.title}
            </h3>
          </Link>
          <p>{element.description}</p>
        </li>
      );
    });
    return list;
  }
  render() {
    const greaterThan = ">";
    const smallerThan = "<";

    return (
      <main className="work">
        <section className="work_head">
          <div>
            <h1>
              <span>{smallerThan}</span> All Work <span>{greaterThan}</span>
            </h1>
          </div>
          <h2>made with passion.</h2>
        </section>
        <section className="work_list">
          <ul>
            {this.renderList()}
          </ul>
        </section>
      </main>
    );
  }
}
